import { CircularProgress, Grid, Typography } from '@mui/material'
import { candidateRouteConfig } from 'candidate/routes'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { usePageTitle } from 'shared/hooks/usePageTitle'
import { ReactComponent as CompleteImage } from 'shared/assets/intake_part_complete.svg'

const Complete: React.FC = () => {
    usePageTitle('Intake Complete')
    const navigate = useNavigate()
    const [countdown, setCountdown] = useState(3)

    useEffect(() => {
        const countdownInterval = setInterval(() => {
            setCountdown((prevCountdown) => prevCountdown - 1)
        }, 1000)

        return () => {
            clearInterval(countdownInterval)
        }
    }, [])

    useEffect(() => {
        if (countdown === 0) {
            navigate(candidateRouteConfig.dashboard.path, { replace: true })
        }
    }, [countdown, navigate])

    return (
        <Grid
            container
            item
            alignItems="center"
            direction="column"
            margin="auto"
            padding="2rem 3rem"
        >
            <CompleteImage />

            <Typography
                variant="h3"
                sx={{
                    marginTop: '2rem',
                    textAlign: 'center',
                }}
            >
                You've successfully completed the questionnaire.
            </Typography>

            <CircularProgress sx={{ marginTop: '2rem' }} />

            <Typography
                sx={{
                    marginTop: '1rem',
                }}
                variant="body2"
            >
                Loading dashboard in {countdown} seconds...
            </Typography>
        </Grid>
    )
}

export default Complete
